// Cart Terms Checkbox Validation
document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('#checkout');
  const termsCheckbox = document.querySelector('#cart-terms');
  const cartTermsElement = document.querySelector('cart-terms');

  // Only run if terms checkbox exists
  if (!termsCheckbox || !checkoutButton) {
    return;
  }

  checkoutButton.addEventListener('click', function(event) {
    // Check if checkbox is checked
    if (!termsCheckbox.checked) {
      // Prevent form submission
      event.preventDefault();
      event.stopPropagation();
      
      // Show alert/popup
      showTermsAlert();
    }
    // If checked, let the form submit normally
  });

  function showTermsAlert() {
    // Create modal overlay
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'terms-alert-overlay';
    modalOverlay.innerHTML = `
      <div class="terms-alert-modal">
        <div class="terms-alert-content">
          <p>You must agree to the terms and conditions before continuing.</p>
          <button class="terms-alert-ok-button">OK</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modalOverlay);
    
    // Close modal on OK button click
    const okButton = modalOverlay.querySelector('.terms-alert-ok-button');
    okButton.addEventListener('click', function() {
      document.body.removeChild(modalOverlay);
      // Focus on checkbox after closing
      termsCheckbox.focus();
    });
    
    // Close modal on overlay click
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        document.body.removeChild(modalOverlay);
      }
    });
  }
});
